// extracted by mini-css-extract-plugin
export default {"flagImage":"FlagImage_flagImage__8dSCp"};